import React from "react";
import { ModalBase } from "../../../../../Components/Modais/ModalBase/ModalBase";
import ButtonActions from "../../../../../Components/Buttons/ButtonActions/ButtonActions";
import DocumentPreview from "../../../shared/components/DocumentPreview/DocumentPreview";
import { getUserDocument } from "../../../shared/utils/audbilityFormatters";

const ModalViewDocument = ({
  open,
  onClose,
  onApprove,
  onReject,
  selectedDocument,
}) => {
  const document = getUserDocument(selectedDocument);

  return (
    <ModalBase
      animated={false}
      open={open}
      onCancel={onClose}
      title="Documento enviado"
      width={800}
      footerAlign="center"
      footer={
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "16px",
            width: "100%",
          }}
        >
          <ButtonActions variant="danger" onClick={onReject} text="RECUSAR" />
          <ButtonActions variant="primary" onClick={onApprove} text="APROVAR" />
        </div>
      }
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "500px",
        }}
      >
        <DocumentPreview
          document={document}
          documentUrl={document?.document_url || selectedDocument?.document_url}
        />
      </div>
    </ModalBase>
  );
};

export default ModalViewDocument;
